"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Cn = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Cn = function Cn(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 3.2H0v9.6h16V3.2zM7.525 4.888l.532-.122-.502-.213.049-.543-.359.41-.502-.213.28.468-.357.41.53-.121.28.468.05-.544zM2.733 7.216l-.506 1.557L3.55 7.81l1.323.962-.506-1.557 1.325-.963H4.054L3.55 4.7l-.504 1.553H1.408l1.325.963zm6.73-.671l-.538-.094-.256.483-.077-.54-.536-.094.489-.24-.077-.54.38.392.49-.24-.256.481.38.392zm-.654 2.192l.453.305-.188-.513.43-.335-.545.019-.187-.513-.15.525-.544.02.451.303-.15.525.43-.336zm-1.312 1.939l-.3-.456-.527.144.341-.426-.299-.455.51.192.34-.426-.025.546.51.192-.525.144-.025.545z",
    fill: "#DE2910"
  }));
};

exports.Cn = Cn;
var _default = Cn;
exports.default = _default;